import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { createUser } from '../../store/authSlice';

const Register = () => {
  const dispatch = useDispatch();
  const [navigateToLogin, setNavigateToLogin] = useState(false);
  const [form, setForm] = useState({});
  const handleForm = (field, value) => {
    setForm((form) => {
      return { ...form, [field]: value };
    });
  };
  console.log({ form });
  const userFields = [
    { id: 'firstName', title: 'First Name' },
    { id: 'lastName', title: 'Last Name' },
    { id: 'email', title: 'Email' },
    { id: 'password', title: 'Password' },
    { id: 'password2', title: 'Confirm Password' },
  ];
  if (navigateToLogin) {
    return <Navigate to='/login/SDFWE_ORMTLDR' />;
  }

  return (
    <section id='hero' className='d-flex align-items-center' style={{ backgroundColor: 'white' }}>
      <div className='container'>
        <div className='row'>
          <div
            className='col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <h1 className='text-dark'>Become a Member</h1>
            {userFields.map((field) => (
              <div className='btn-group-vertical mt-2' key={field.id}>
                <b>{field.title}</b>
                <input type='text' className='form-control' onChange={(e) => handleForm(field.id, e.target.value)} />
              </div>
            ))}

            <button
              className='btn btn-dark mt-2'
              onClick={() => {
                dispatch(createUser(form));
                setNavigateToLogin(true);
              }}
            >
              Submit
            </button>
          </div>
          <div className='col-lg-6 order-1 order-lg-2 hero-img' data-aos='zoom-in' data-aos-delay='200'>
            <img src='assets/img/hero-img.png' className='img-fluid animated' alt='' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
